import { render } from "./CreateUpdateQuestionsAnswers.vue?vue&type=template&id=77a19318&scoped=true"
import script from "./CreateUpdateQuestionsAnswers.vue?vue&type=script&lang=js"
export * from "./CreateUpdateQuestionsAnswers.vue?vue&type=script&lang=js"

import "./CreateUpdateQuestionsAnswers.vue?vue&type=style&index=0&id=77a19318&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a19318"]])

export default __exports__